<!-- <app-spinner [state]="spinnerState"></app-spinner> -->
<app-fullscreen-spinner
  [visible]="spinnerState.visible"
  [message]="spinnerState.message">
</app-fullscreen-spinner>
@if (isPublicRoute) {
    <router-outlet></router-outlet>
} @else if (authenticated) {
	<ng-container>
		<app-full-layout></app-full-layout>
	</ng-container>
} @else {
	<app-sign-in></app-sign-in>
}